"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectStore = exports.InjectedStore = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const typedi_1 = require("typedi");
const index_1 = require("./index");
class InjectedStore {
    constructor(store, bridge, 
    /**
     * Reducer name that needs to be specified
     * @private
     */
    reducerName) {
        this.store = store;
        this.bridge = bridge;
        this.reducerName = reducerName;
        this.getState = this.getState.bind(this);
        this.dispatch = this.dispatch.bind(this);
        this[Symbol.observable] = this[Symbol.observable].bind(this);
        this.subscribe = this.store.subscribe;
    }
    /**
     * Get store state for specified reducer name
     */
    getState() {
        return this.store.getState()[this.reducerName];
    }
    /**
     * Get access only for actions that specified by reducer name
     * @param action - redux action
     */
    dispatch(action) {
        if (action.payload.identifier !== this.reducerName) {
            throw new Error(`Can not dispatch action for "${action.payload.identifier}" reducer. Current store instance is restricted to "${this.reducerName}" reducer only.`);
        }
        if (!(this.reducerName in this.store.reducers) &&
            (action.type.includes(bridge_schema_1.bridgeObjectAdded) ||
                action.type.includes(bridge_schema_1.bridgeObjectChanged))) {
            const isObjectAdded = action.type.includes(bridge_schema_1.bridgeObjectAdded);
            this.bridge.emit(isObjectAdded ? bridge_schema_1.bridgeObjectAdded : bridge_schema_1.bridgeObjectChanged, action.payload);
        }
        return this.store.dispatch(action);
    }
    [Symbol.observable]() {
        const self = this;
        return {
            subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) {
                    throw new TypeError(`Expected the observer to be an object. Instead, got: ${typeof observer}`);
                }
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) {
                        observerAsObserver.next(self.getState());
                    }
                }
                observeState();
                const unsubscribe = self.subscribe(observeState);
                return { unsubscribe };
            },
            [Symbol.observable]() {
                return this;
            },
        };
    }
    replaceReducer(_nextReducer) {
        return;
    }
}
exports.InjectedStore = InjectedStore;
/**
 *  Decorator to restrict store access
 * @param reducerName - name of reducer
 */
function InjectStore(reducerName) {
    return function (target, propertyName, index) {
        typedi_1.Container.registerHandler({
            object: target,
            propertyName,
            index,
            value: () => {
                const storeInstance = typedi_1.Container.get(index_1.StoreToken);
                // @ts-ignore
                const bridgeInstance = typedi_1.Container.get(bridge_schema_1.BridgeInterface);
                return new InjectedStore(storeInstance, bridgeInstance, reducerName);
            },
        });
    };
}
exports.InjectStore = InjectStore;
